'use client'
import Link from 'next/link'
import * as React from 'react'
import { track, type GAParams } from '@/lib/analytics/ga4'

// Thin client wrapper around next/link that fires a GA4 event on click before
// navigating. Lets server components (e.g. CtaBand) keep all their markup and
// only turn the anchor itself into a client boundary. forwardRef so it also
// works as a Radix `asChild` slot child (Button asChild).
type Props = React.ComponentProps<typeof Link> & { event: string; params?: GAParams }

export const TrackedLink = React.forwardRef<HTMLAnchorElement, Props>(function TrackedLink(
  { event, params, onClick, children, ...rest },
  ref,
) {
  return (
    <Link
      ref={ref}
      {...rest}
      onClick={(e) => {
        try {
          track(event, params)
        } catch {
          /* never let analytics break navigation */
        }
        onClick?.(e)
      }}
    >
      {children}
    </Link>
  )
})
